module.exports = __webpack_public_path__ + "static/amex-card-9b64e59a8b6c6b96e41f1a1d6104306e.png";